<div class="gwc-facility-finder">
  <div class="gwc-facility-finder__top">
    <img class="gwc-facility-finder__icon"
      alt="Passport Photo"
      src="assets/wizard/icon-step-passport-photo.svg"/>
    <div class="gwc-facility-finder__top-content">
      <h1>
        {{ props['heading'] }}
      </h1>
    </div>
  </div>
  <section class="gwc-facility-finder__body">
    <div class="gwc-facility-finder__list">
      <div class="gwc-facility-finder__top-search">
        <mat-form-field class="gwc-facility-finder__top-zip">
          <mat-label>ZIP Code</mat-label>
          <input matInput
            [formControl]="zipCodeControl"/>
          <div matSuffix>
            <span class="gwc-facility-finder__top-search-separator"></span>
            <button mat-icon-button
              color="primary"
              (click)="getFacilities()">
              <img src="assets/wizard/icon-search.svg"
                class="gwc-facility-finder__top-search-icon"
                alt="Search">
            </button>
          </div>
        </mat-form-field>
      </div>
      @if (facilities().length > 0) {
        @if (loadingFacilities()) {
          <div class="gwc-facility-finder__loading">
            <mat-spinner class="gwc-facility-finder__loading-spinner"></mat-spinner>
          </div>
        } @else {
          <ul>
            @for (facility of facilities(); track facility.uuid) {
              <div class="gwc-facility-finder__list-item-container">
                <li class="gwc-facility-finder__list-item"
                  (click)="selectFacility(facility)"
                  [class.gwc-facility-finder__list-item--selected]="formControl.value && facility.uuid === formControl.value.uuid">
                  <h4>{{ facility.company ? companies[facility.company] : facility.name }}</h4>
                  <p>
                    {{ facility.address.address_1 }} {{ facility.address.address_2 ? ', ' + facility.address.address_2 : '' }}<br/>
                    <!-- {{ facility.phone | phone: 'US' }} <br/> -->
                    {{ facility.distance | number:'1.2-2'}} miles away
                  </p>
                </li>
                <!-- Mobile only -->
                @if (formControl.value && facility.uuid === formControl.value.uuid) {
                  <div class="gwc-facility-finder__selected--mobile">
                    <section class="gwc-facility-finder__selected-content">
                      <div class="gwc-facility-finder__selected-header">
                        I can go to this <strong>{{ formControl.value.company ? companies[formControl.value.company] : formControl.value.name }}</strong>
                      </div>
                      <div class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--address">
                        <img src="assets/wizard/icon-location.svg"
                          alt="Location">
                        <span>{{ formControl.value.address.address_1 }} {{ formControl.value.address.address_2 ? ', ' + formControl.value.address.address_2 : '' }}</span>
                        <span>{{ formControl.value.address.city }} {{ formControl.value.address.state }} {{ formControl.value.address.zip }}</span>

                      </div>
                      <div class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--phone">
                        <img src="assets/wizard/icon-phone.svg"
                          alt="Phone">
                        <span>
                          {{ formControl.value.phone | phone: 'US' }}
                        </span>
                      </div>
                      @if (formControl.value.hours) {
                        <div class="gwc-facility-finder__hours-container">
                          <img src="assets/wizard/icon-clock.svg"
                          alt="Clock">
                          <ul class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--hours">
                            @for (day of weekdays | keyvalue: originalOrder | filter: hoursAvailable; track day.key) {
                              <li>
                                <span>{{ day.value }}</span> {{ formControl.value.hours[$any(day.key)].open }} - {{ formControl.value.hours[$any(day.key)].close }}
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </section>
                    <div class="gwc-facility-finder__map">
                      <google-map	width="100%"
                        height="250px"
                        [options]="mapOptions"
                        [center]="mapCenter"
                        [zoom]="14">
                        <map-marker [position]="mapCenter"
                        ></map-marker>
                      </google-map>
                    </div>
                  </div>
                }
              </div>
            }
          </ul>
        }
      }
    </div>
    @if (facilities().length > 0 && formControl.value && formControl.value.address) {
      <div class="gwc-facility-finder__selected">
        <section class="gwc-facility-finder__selected-content">
          <div class="gwc-facility-finder__selected-header">
            I can go to this <br><strong>{{ formControl.value.company ? companies[formControl.value.company] : formControl.value.name }}</strong>
          </div>
          <div class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--address">
            <img src="assets/wizard/icon-location.svg"
              alt="Location">
            <span>
              {{ formControl.value.address.address_1 }} {{ formControl.value.address.address_2 ? ', ' + formControl.value.address.address_2 : '' }}<br/>
              {{ formControl.value.address.city }}, {{ formControl.value.address.state }} {{ formControl.value.address.zip }}
            </span>

          </div>
          <div class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--phone">
            <img src="assets/wizard/icon-phone.svg"
              alt="Phone">
            <span>
              {{ formControl.value.phone | phone: 'US' }}
            </span>
          </div>
          @if (formControl.value.hours) {
            <div class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--hours">
              <img src="assets/wizard/icon-clock.svg"
                alt="Clock">
              <ul class="">
                @for (day of weekdays | keyvalue: originalOrder | filter: hoursAvailable; track day.key) {
                  <li>
                    <span>{{ day.value }}</span> {{ formControl.value.hours[$any(day.key)].open }} - {{ formControl.value.hours[$any(day.key)].close }}
                  </li>
                }
              </ul>
            </div>
          }
          <!-- @if (formControl.value.comments) {
            <div class="gwc-facility-finder__selected-item gwc-facility-finder__selected-item--comments">
              {{ formControl.value.comments }}
            </div>
          } -->
        </section>
        <div class="gwc-facility-finder__map">
          <google-map	width="100%"
            height="100%"
            [options]="mapOptions"
            [center]="mapCenter"
            [zoom]="14">
            <map-marker [position]="mapCenter"
            ></map-marker>
          </google-map>
        </div>
      </div>
    } @else {
      <div class="gwc-facility-finder__empty">
        No locations found within 500 miles from the specified zipcode.<br /> Please try a different zip code.
      </div>
    }
  </section>
</div>
